<footer class="hidden md:block relative overflow-hidden bg-azul-profundo text-white">
  <img src="https://deportivo-municipal.s3.us-east-2.amazonaws.com/assets/fondo-footer.png" alt="" aria-hidden="true"
    class="absolute inset-0 w-full h-full object-cover object-[center_30%] opacity-10 mix-blend-luminosity pointer-events-none z-0" />

  <div class="relative z-10 p-6 sm:p-8 lg:px-12 lg:pt-13.75 lg:pb-10">
    <div class="max-w-7xl mx-auto">

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1.2fr_2fr_1fr] gap-8 lg:gap-12 items-start">

        <div
          class="flex flex-col gap-4 sm:col-span-2 lg:col-span-1 text-center sm:text-left items-center sm:items-start">
          <a class="inline-flex items-center gap-1.5 no-underline text-white shrink-0" routerLink="/">
            <img class="w-14 h-14 object-contain" src="https://deportivo-municipal.s3.us-east-2.amazonaws.com/assets/logo2.png" alt="Escudo Municipal" />
            <span class="flex flex-col gap-0.5">
              <span class="font-logo font-normal text-[9.08px] uppercase">
                CLUB CENTRO DEPORTIVO
              </span>
              <span class="font-body font-normal text-2xl uppercase leading-[0.95] tracking-tight text-center">
                MUNICIPAL
              </span>
              <div class="flex items-center gap-1.5 w-full mt-0.5">
                <span class="flex-1 h-[0.75px] bg-white"></span>
                <span class="font-logo font-normal text-[9.08px] leading-none text-white">1935</span>
                <span class="flex-1 h-[0.75px] bg-white"></span>
              </div>
            </span>
          </a>

          <p class="font-body text-sm sm:text-base font-semibold leading-relaxed text-gris-claro max-w-sm mt-1">
            La pasión del hincha más fiel y creyente, <br class="hidden sm:inline" />
            90 años de historia y semillero de leyendas.
          </p>
        </div>

        <div class="flex flex-col gap-8 sm:col-span-1 lg:col-span-1">
          <div class="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-4 lg:gap-6 text-center sm:text-left">

            <nav class="flex flex-col gap-2">
              <h3 class="font-bold text-white text-base lg:text-3xl uppercase tracking-wider mb-4 pb-4">CLUB</h3>
              <a routerLink="/history"
                class="font-body text-sm font-light text-gris-claro  transition-colors py-2">Historia</a>
              <a routerLink="/sponsors"
                class="font-body text-sm font-light text-gris-claro  transition-colors py-2">Patrocinios</a>
              <a routerLink="/tickets"
                class="font-body text-sm font-light text-gris-claro  transition-colors py-2">Entradas</a>
              <a routerLink="/store"
                class="font-body text-sm font-light text-gris-claro  transition-colors py-2">Tienda
                edil</a>
            </nav>

            <nav class="flex flex-col gap-2">
              <h3 class="font-bold text-white text-base lg:text-3xl uppercase tracking-wider mb-4 pb-4">ACTUALIDAD</h3>
              <a routerLink="/squad"
                class="font-body text-sm font-light text-gris-claro  transition-colors py-2">Plantel
                2026</a>
              <a routerLink="/academy"
                class="font-body text-sm font-light text-gris-claro  transition-colors py-2">Academia</a>
              <a routerLink="/table"
                class="font-body text-sm font-light text-gris-claro  transition-colors py-2">Tabla de
                posiciones</a>
            </nav>

            <nav class="flex flex-col gap-2">
              <h3 class="font-bold text-white text-base lg:text-3xl uppercase tracking-wider mb-4 pb-4">REDES</h3>
              <a routerLink="/members"
                class="font-body text-sm font-light text-gris-claro  transition-colors py-2">Socios</a>
              <a routerLink="/news"
                class="font-body text-sm font-light text-gris-claro  transition-colors py-2">Noticias</a>
              <a href="https://youtube.com/@clubdeportivomunicipaltv"
                target="_blank" rel="noopener noreferrer"
                class="font-body text-sm font-light text-gris-claro  transition-colors py-2">Canal
                oficial</a>
            </nav>
          </div>

          <div
            class="hidden lg:flex flex-wrap items-center gap-2 text-[15px] leading-5 font-normal font-display tracking-wider uppercase">
            <a routerLink="/profile/terms" class=" transition-colors">TÉRMINOS Y CONDICIONES</a>
            <span>|</span>
            <a routerLink="/profile/terms" class=" transition-colors">POLÍTICAS DE PRIVACIDAD</a>
            <span>|</span>
            <a routerLink="/sponsors" class=" transition-colors">PATROCINADORES</a>
          </div>
        </div>

        <div
          class="flex flex-col gap-6 sm:col-span-1 lg:col-span-1 text-center sm:text-left items-center sm:items-start">
          <h3 class="font-bold text-white text-base lg:text-3xl uppercase tracking-wider">CONTACTOS</h3>
          <a href="mailto:contacto@clubdeportivomunicipal.pe"
            class="font-body text-16px font-semibold text-gris-claro  transition-colors">
            contacto@clubdeportivomunicipal.pe
          </a>

          <div class="flex items-center justify-center sm:justify-start gap-2.5 mt-1">
            <a href="https://www.instagram.com/clubdeportivomunicipal?stkn=NXowcXFhcTJrbWhk"
              target="_blank" rel="noopener noreferrer" aria-label="Instagram"
              class="flex items-center justify-center text-white transition-all hover:text-rojo-brillante!">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
              </svg>
            </a>
            <a href="https://www.facebook.com/share/18WtxURNYa/?mibextid=wwXIfr"
              target="_blank" rel="noopener noreferrer" aria-label="Facebook"
              class="flex items-center justify-center text-white transition-all hover:text-rojo-brillante!">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
              </svg>
            </a>
            <a href="https://youtube.com/@clubdeportivomunicipaltv?si=ZrKXrpEGA8YJuAFv"
              target="_blank" rel="noopener noreferrer" aria-label="YouTube"
              class="flex items-center justify-center text-white transition-all hover:text-rojo-brillante!">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path
                  d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z" />
                <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" />
              </svg>
            </a>
            <a href="https://www.tiktok.com/@clubdeportivomunicipal"
              target="_blank" rel="noopener noreferrer" aria-label="TikTok"
              class="flex items-center justify-center text-white transition-all hover:text-rojo-brillante!">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" class="w-6 h-6">
                <g id="tiktok">
                  <path id="Union" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                    d="M17.0453 20.667C10.5636 21.1171 5 25.736 5 32.8154 5 39.5448 10.3929 45 17.0453 45c6.6524 0 12.0453 -5.4552 12.0453 -12.1846l-0.348 -15.19c3.0271 2.3352 7.8621 3.7477 12.3364 3.9734 0.8005 0.0404 1.5682 -0.3232 1.7552 -1.1026 0.0953 -0.3971 0.1658 -0.9137 0.1658 -1.573s-0.0705 -1.1759 -0.1658 -1.5729c-0.187 -0.7796 -0.9565 -1.118 -1.7542 -1.1978 -6.0495 -0.6056 -11.7467 -5.5 -12.5614 -11.27969 -0.1032 -0.73153 -0.513 -1.40612 -1.228 -1.59216C26.7222 3.13273 25.9644 3 25.0755 3c-0.89 0 -1.6485 0.13304 -2.2171 0.28116 -0.7139 0.18595 -1.1394 0.85621 -1.1564 1.59373l-0.6416 27.94051c0 2.2431 -1.7976 4.0615 -4.0151 4.0615 -2.2175 0 -4.0151 -1.8184 -4.0151 -4.0615 0 -2.332 1.949 -3.8331 4.0151 -4.2176"
                    stroke-width="3.5"></path>
                </g>
              </svg>
            </a>
          </div>

          <a href="mailto:contacto@clubdeportivomunicipal.pe?subject=Libro%20de%20Reclamaciones"
            class="inline-block mt-3 hover:opacity-90 transition-opacity">
            <img src="https://deportivo-municipal.s3.us-east-2.amazonaws.com/assets/libro-reclamaciones-footer.png" alt="Libro de Reclamaciones"
              class="h-14 w-auto object-contain" />
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="relative z-10 bg-rojo-brillante">
    <p class="font-ui text-xs sm:text-sm lg:text-[15px] h-15 font-semibold leading-normal text-white text-center py-4 px-4">
      © {{ currentYear }} Club Centro Deportivo Municipal - Todos los derechos reservados.
    </p>
  </div>
</footer>

<footer class="footer-mobile flex flex-col md:hidden relative overflow-hidden text-white">
  <div class="footer-mobile__main">
    <img src="https://deportivo-municipal.s3.us-east-2.amazonaws.com/assets/fondo-footer.png" alt="" aria-hidden="true"
      class="absolute inset-0 w-full h-full object-cover object-center opacity-10 mix-blend-luminosity pointer-events-none" />

    <div class="footer-mobile__inner">
      <a class="flex justify-center mb-8 no-underline" routerLink="/" aria-label="Ir al inicio">
        <img class="footer-mobile__logo" src="https://deportivo-municipal.s3.us-east-2.amazonaws.com/assets/logo2.png" alt="Escudo Municipal" />
      </a>

      <div class="footer-mobile__grid">
        <nav class="footer-mobile__section" aria-label="Redes">
          <h3 class="footer-mobile__section-title">Redes</h3>
          <a routerLink="/members" class="footer-mobile__link">Socios</a>
          <a routerLink="/news" class="footer-mobile__link">Noticias</a>
          <a href="https://youtube.com/@clubdeportivomunicipaltv" target="_blank"
            rel="noopener noreferrer" class="footer-mobile__link">Canal oficial</a>
        </nav>

        <nav class="footer-mobile__section" aria-label="Club">
          <h3 class="footer-mobile__section-title">Club</h3>
          <a routerLink="/history" class="footer-mobile__link">Historia</a>
          <a routerLink="/sponsors" class="footer-mobile__link">Patrocinios</a>
          <a routerLink="/tickets" class="footer-mobile__link">Entradas</a>
          <a routerLink="/store" class="footer-mobile__link">Tienda edil</a>
        </nav>

        <nav class="footer-mobile__section" aria-label="Actualidad">
          <h3 class="footer-mobile__section-title">Actualidad</h3>
          <a routerLink="/squad" class="footer-mobile__link">Plantel 2026</a>
          <a routerLink="/academy" class="footer-mobile__link">Academia</a>
          <a routerLink="/table" class="footer-mobile__link">Tabla de posiciones</a>
        </nav>

        <div class="footer-mobile__section">
          <h3 class="footer-mobile__section-title">Contactos</h3>
          <a href="mailto:contacto@clubdeportivomunicipal.pe" class="footer-mobile__email">
            contacto@clubdeportivomunicipal.pe
          </a>
          <a href="mailto:contacto@clubdeportivomunicipal.pe?subject=Libro%20de%20Reclamaciones"
            class="footer-mobile__libro hover:opacity-90 transition-opacity">
            <img src="https://deportivo-municipal.s3.us-east-2.amazonaws.com/assets/libro-reclamaciones-footer.png" alt="Libro de Reclamaciones" />
          </a>
        </div>
      </div>

      <div class="footer-mobile__social">
        <a href="https://www.instagram.com/clubdeportivomunicipal" target="_blank"
          rel="noopener noreferrer" aria-label="Instagram">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
          </svg>
        </a>
        <a href="https://www.facebook.com/clubdeportivomunicipal" target="_blank"
          rel="noopener noreferrer" aria-label="Facebook">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
          </svg>
        </a>
        <a href="https://youtube.com/@clubdeportivomunicipaltv" target="_blank"
          rel="noopener noreferrer" aria-label="YouTube">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path
              d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z" />
            <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" />
          </svg>
        </a>
        <a href="https://www.tiktok.com/@clubdeportivomunicipal" target="_blank"
          rel="noopener noreferrer" aria-label="TikTok">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48">
            <g id="tiktok">
              <path id="Union" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                d="M17.0453 20.667C10.5636 21.1171 5 25.736 5 32.8154 5 39.5448 10.3929 45 17.0453 45c6.6524 0 12.0453 -5.4552 12.0453 -12.1846l-0.348 -15.19c3.0271 2.3352 7.8621 3.7477 12.3364 3.9734 0.8005 0.0404 1.5682 -0.3232 1.7552 -1.1026 0.0953 -0.3971 0.1658 -0.9137 0.1658 -1.573s-0.0705 -1.1759 -0.1658 -1.5729c-0.187 -0.7796 -0.9565 -1.118 -1.7542 -1.1978 -6.0495 -0.6056 -11.7467 -5.5 -12.5614 -11.27969 -0.1032 -0.73153 -0.513 -1.40612 -1.228 -1.59216C26.7222 3.13273 25.9644 3 25.0755 3c-0.89 0 -1.6485 0.13304 -2.2171 0.28116 -0.7139 0.18595 -1.1394 0.85621 -1.1564 1.59373l-0.6416 27.94051c0 2.2431 -1.7976 4.0615 -4.0151 4.0615 -2.2175 0 -4.0151 -1.8184 -4.0151 -4.0615 0 -2.332 1.949 -3.8331 4.0151 -4.2176"
                stroke-width="3.5"></path>
            </g>
          </svg>
        </a>
      </div>

      <nav class="footer-mobile__legal" aria-label="Enlaces legales">
        <a routerLink="/profile/terms">Términos y condiciones</a>
        <span aria-hidden="true">|</span>
        <a routerLink="/profile/terms">Políticas de privacidad</a>
        <span aria-hidden="true">|</span>
        <a routerLink="/sponsors">Patrocinadores</a>
      </nav>
    </div>
  </div>

  <div class="footer-mobile__red-bar">
    <p class="footer-mobile__copyright">
      © {{ currentYear }} Club Centro Deportivo Municipal - Todos los derechos reservados.
    </p>
  </div>
</footer>
